import { fontExtraBold, maxZIndex } from '../../style/styled-components/cssGlobalVariables';
import { styled } from '../ThemeConfigConnector/ThemeConfigConnnector';

export const SubscriptionErrorWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(19, 19, 32, 0.95);
    overflow: auto;
    z-index: ${maxZIndex + 5};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const SubscriptionErrorTitle = styled.p`
    font-family: ${fontExtraBold};
    font-size: 32px;
    line-height: 40px;
    color: var(--color-dark-body);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
    margin-bottom: 16px;
`;

export const SubscriptionErrorBody = styled.p`
    color: var(--color-dark-body);
    margin-bottom: 32px;
`;
